export default "__VITE_ASSET__6d68e25c__"